;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { Locale, Options } from "react-joyride";

const TOUR_BEACON_FALLBACK_COLOR = "oklch(0.75 0.15 85)";

/** Top-level `useJoyride` locale — not merged from `options`. */
export const tourJoyrideLocale: Partial<Locale> = {
	last: "Finish",
};
const TARGET_WAIT_TIMEOUT_MS = 3_000;
const TOUR_STEP_BEFORE_TIMEOUT_MS = 3_500;

export const TOUR_TARGET_WAIT_TIMEOUT_MS = TARGET_WAIT_TIMEOUT_MS;

export function readTourJoyridePrimaryColor(): string {
	if (typeof window === "undefined") {
		return TOUR_BEACON_FALLBACK_COLOR;
	}

	const tourBeacon = getComputedStyle(document.documentElement)
		.getPropertyValue("--tour-beacon")
		.trim();
	if (tourBeacon) {
		return tourBeacon;
	}

	const orange = getComputedStyle(document.documentElement)
		.getPropertyValue("--orange")
		.trim();
	return orange || TOUR_BEACON_FALLBACK_COLOR;
}

export function readTourJoyrideSurfaceColor(): string {
	if (typeof window === "undefined") {
		return "#ffffff";
	}

	const background = getComputedStyle(document.documentElement)
		.getPropertyValue("--background")
		.trim();

	return background || "#ffffff";
}

export function createTourJoyrideOptions({
	primaryColor,
	surfaceColor,
}: {
	primaryColor: string;
	surfaceColor: string;
}): Partial<Options> {
	return {
		arrowColor: surfaceColor,
		beaconSize: 36,
		beforeTimeout: TOUR_STEP_BEFORE_TIMEOUT_MS,
		disableFocusTrap: true,
		dismissKeyAction: "close",
		loaderDelay: 400,
		overlayClickAction: false,
		primaryColor,
		scrollOffset: 80,
		skipBeacon: true,
		targetWaitTimeout: TARGET_WAIT_TIMEOUT_MS,
		zIndex: 10000,
	};
}
